(function () {
	if (window.__novaBreadcrumbsInit) return;
	window.__novaBreadcrumbsInit = true;

	document.addEventListener('click', function (e) {
		var toggle = e.target.closest('.nova-breadcrumbs__ellipsis-toggle');
		if (!toggle) return;
		e.preventDefault();

		var list = toggle.closest('.nova-breadcrumbs__list');
		if (!list) return;

		// Reveal the collapsed breadcrumb levels inline (they wrap onto further lines).
		list.classList.add('nova-breadcrumbs__list--expanded');
		toggle.setAttribute('aria-expanded', 'true');
	});
})();
